
/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { MatDialog } from '@angular/material/dialog';
import { MyInjector } from '@src/app/app.module';
import { ActionColor, IFormAction } from '@src/app/shared/form/form.component';

import { MergeSupplierComponent } from '@src/app/modules/supply/preferred-supplier-page/merge-supplier/merge-supplier.component';
import { Supplier } from '@src/app/model/supplier';


export class MergeSupplierAction implements IFormAction {
    name = $localize`Merge`;
    color: ActionColor = 'primary';
    show = false;
    icon = 'arrow_and_edge';
    approvalNeeded = false;
    disabled = false;
    approvalText: string;
    tipText = $localize `Merge this supplier record and all related data into another supplier record`;

    supplier: Supplier;

    dialog = MyInjector.instance.get(MatDialog);

    action() {
        const dialogRef = this.dialog.open(MergeSupplierComponent, {data: this.supplier});
        return dialogRef.afterClosed();
    }

    setup(supplier: Supplier) {
        this.supplier = supplier;
        this.show = true;
    }
}
